<template>
  <div class="pieOne"></div>
</template>

<script>
import { reqState } from "@/network/homePage";
export default {
  name: "pieOne",
  methods: {
    async getData() {
      let { data } = await reqState();

      if (data.code == 200) {
        var pieData = [];
        // console.log(data);
        for (const item of data.data) {
          pieData.push({
            value: item.total,
            name:
              item.is_release == 0
                ? "上架"
                : item.is_release == 1
                ? "未上架"
                : item.is_release == 2
                ? "未审核"
                : "下架",
          });
        }
      }
      this.$echarts.pieone(".pieOne", {
        pieData,
      });
  
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style lang="scss" scoped>
.pieOne {
  width: 100%;
  height: 100%;
}
</style>